var map = {
	"./": 59624,
	"./App": 82835,
	"./App.css": 93508,
	"./App.js": 82835,
	"./App.test": 60754,
	"./App.test.js": 60754,
	"./PageRender": 77839,
	"./PageRender.jsx": 77839,
	"./Routes": 65227,
	"./Routes.jsx": 65227,
	"./assets/Bulk Upload Sample.csv": 55917,
	"./assets/audio.svg": 81146,
	"./assets/catord.svg": 24396,
	"./assets/check.svg": 91215,
	"./assets/contest.svg": 39319,
	"./assets/create.svg": 70893,
	"./assets/delete.gif": 4988,
	"./assets/delete2.gif": 66459,
	"./assets/delete3.gif": 50624,
	"./assets/done.gif": 16218,
	"./assets/edit.svg": 68044,
	"./assets/file-icon.png": 83241,
	"./assets/fonts/Akira.otf": 29298,
	"./assets/fonts/ClashDisplay-Regular.otf": 59082,
	"./assets/fonts/K2D.ttf": 72432,
	"./assets/fonts/Krub-Regular.woff": 15599,
	"./assets/fonts/Lato-Regular.ttf": 55661,
	"./assets/fonts/Mulish-VariableFont_wght.ttf": 22894,
	"./assets/fonts/Nunito-Regular.ttf": 91988,
	"./assets/fonts/Poppins-Regular.otf": 63441,
	"./assets/fonts/Sansation_Regular.ttf": 40619,
	"./assets/fonts/Segoe UI.ttf": 29886,
	"./assets/fonts/WorkSans-VariableFont_wght.ttf": 8693,
	"./assets/funico.svg": 28345,
	"./assets/guessico.svg": 97981,
	"./assets/import.svg": 7604,
	"./assets/loginbg.png": 15380,
	"./assets/loginbg2.png": 89238,
	"./assets/loginimg.png": 27078,
	"./assets/logo.svg": 69574,
	"./assets/logo2.svg": 61780,
	"./assets/logolight.svg": 26127,
	"./assets/mail.svg": 22059,
	"./assets/main.svg": 59462,
	"./assets/manage.svg": 81926,
	"./assets/manageico.svg": 8268,
	"./assets/more - vertical.svg": 97007,
	"./assets/notification.svg": 90313,
	"./assets/profile.svg": 2317,
	"./assets/questionico.svg": 32021,
	"./assets/questiontable.svg": 71861,
	"./assets/reports.svg": 67025,
	"./assets/search.svg": 51238,
	"./assets/settings.svg": 84369,
	"./assets/sidebar-icons/activities.svg": 53591,
	"./assets/sidebar-icons/activity-active.svg": 84845,
	"./assets/sidebar-icons/audio-active.svg": 35622,
	"./assets/sidebar-icons/audio.svg": 2785,
	"./assets/sidebar-icons/contest-active.svg": 87921,
	"./assets/sidebar-icons/contest.svg": 18272,
	"./assets/sidebar-icons/daily-quiz-active.svg": 95987,
	"./assets/sidebar-icons/daily-quiz.svg": 29479,
	"./assets/sidebar-icons/dashboard-active.svg": 8828,
	"./assets/sidebar-icons/dashboard.svg": 42493,
	"./assets/sidebar-icons/exam-module-active.svg": 72998,
	"./assets/sidebar-icons/exam-module.svg": 70853,
	"./assets/sidebar-icons/fun-active.svg": 84162,
	"./assets/sidebar-icons/fun.svg": 11921,
	"./assets/sidebar-icons/guess-active.svg": 27582,
	"./assets/sidebar-icons/guess-word.svg": 4499,
	"./assets/sidebar-icons/leaderboard-active.svg": 1344,
	"./assets/sidebar-icons/leaderboard.svg": 18191,
	"./assets/sidebar-icons/logout.svg": 97635,
	"./assets/sidebar-icons/math-quiz-active.svg": 78922,
	"./assets/sidebar-icons/math-quiz.svg": 95131,
	"./assets/sidebar-icons/notification-active.svg": 79200,
	"./assets/sidebar-icons/notification.svg": 66943,
	"./assets/sidebar-icons/payment-active.svg": 54360,
	"./assets/sidebar-icons/payments.svg": 68394,
	"./assets/sidebar-icons/quiz-active.svg": 4603,
	"./assets/sidebar-icons/quiz-zone.svg": 95822,
	"./assets/sidebar-icons/settings-active.svg": 83919,
	"./assets/sidebar-icons/settings.svg": 57493,
	"./assets/sidebar-icons/user-active.svg": 45422,
	"./assets/sidebar-icons/users.svg": 98078,
	"./assets/sliderimg.png": 64385,
	"./assets/sms.svg": 69059,
	"./assets/subcat.svg": 76781,
	"./assets/subico.svg": 24600,
	"./assets/tableimg.png": 87323,
	"./assets/totalico.svg": 63298,
	"./assets/view.svg": 4987,
	"./components/Logo": 34942,
	"./components/Logo/": 34942,
	"./components/Logo/index": 34942,
	"./components/Logo/index.jsx": 34942,
	"./components/buttons/button": 17969,
	"./components/buttons/button.jsx": 17969,
	"./components/buttons/loading.css": 43666,
	"./components/buttons/modalbtn": 1885,
	"./components/buttons/modalbtn.jsx": 1885,
	"./components/charts/areachart": 11525,
	"./components/charts/areachart/": 11525,
	"./components/charts/areachart/index": 11525,
	"./components/charts/areachart/index.jsx": 11525,
	"./components/charts/barchart": 68908,
	"./components/charts/barchart/": 68908,
	"./components/charts/barchart/index": 68908,
	"./components/charts/barchart/index.jsx": 68908,
	"./components/inputs/fileinputs": 89467,
	"./components/inputs/fileinputs.jsx": 89467,
	"./components/inputs/radioinputs": 44145,
	"./components/inputs/radioinputs.jsx": 44145,
	"./components/inputs/selectinputs": 2197,
	"./components/inputs/selectinputs.jsx": 2197,
	"./components/inputs/textarea": 47279,
	"./components/inputs/textarea.jsx": 47279,
	"./components/inputs/textinputs": 98260,
	"./components/inputs/textinputs.jsx": 98260,
	"./components/maincontainer": 91890,
	"./components/maincontainer/": 91890,
	"./components/maincontainer/index": 91890,
	"./components/maincontainer/index.jsx": 91890,
	"./components/mainheader": 11936,
	"./components/mainheader/": 11936,
	"./components/mainheader/index": 11936,
	"./components/mainheader/index.jsx": 11936,
	"./components/modals/add-badge": 84595,
	"./components/modals/add-badge.jsx": 84595,
	"./components/modals/add-faq": 57797,
	"./components/modals/add-faq.jsx": 57797,
	"./components/modals/add-language": 1872,
	"./components/modals/add-language.jsx": 1872,
	"./components/modals/add-slider": 99615,
	"./components/modals/add-slider.jsx": 99615,
	"./components/modals/add-users": 56423,
	"./components/modals/add-users.jsx": 56423,
	"./components/modals/confirm-delete": 15413,
	"./components/modals/confirm-delete.jsx": 15413,
	"./components/modals/create-category": 2452,
	"./components/modals/create-category.jsx": 2452,
	"./components/modals/create-sub-category": 17440,
	"./components/modals/create-sub-category.jsx": 17440,
	"./components/modals/deleted-modal": 99044,
	"./components/modals/deleted-modal.jsx": 99044,
	"./components/modals/done-modal": 47412,
	"./components/modals/done-modal.jsx": 47412,
	"./components/modals/edit-slider.jsx": 6735,
	"./components/modals/edit-slider.jsx/": 6735,
	"./components/modals/edit-slider.jsx/index": 6735,
	"./components/modals/edit-slider.jsx/index.jsx": 6735,
	"./components/modals/modalcontainer": 2072,
	"./components/modals/modalcontainer.jsx": 2072,
	"./components/modals/sendemail": 39877,
	"./components/modals/sendemail.jsx": 39877,
	"./components/modals/sendsms": 78839,
	"./components/modals/sendsms.jsx": 78839,
	"./components/modals/status-modal": 49118,
	"./components/modals/status-modal.jsx": 49118,
	"./components/sidebar/sidebar": 64800,
	"./components/sidebar/sidebar.jsx": 64800,
	"./components/tables/activities-table": 59086,
	"./components/tables/activities-table/": 59086,
	"./components/tables/activities-table/index": 59086,
	"./components/tables/activities-table/index.jsx": 59086,
	"./components/tables/audio-table": 93296,
	"./components/tables/audio-table/": 93296,
	"./components/tables/audio-table/index": 93296,
	"./components/tables/audio-table/index.jsx": 93296,
	"./components/tables/contest-table": 54553,
	"./components/tables/contest-table/": 54553,
	"./components/tables/contest-table/index": 54553,
	"./components/tables/contest-table/index.jsx": 54553,
	"./components/tables/exam-module-table": 56665,
	"./components/tables/exam-module-table/": 56665,
	"./components/tables/exam-module-table/index": 56665,
	"./components/tables/exam-module-table/index.jsx": 56665,
	"./components/tables/fun-table": 85264,
	"./components/tables/fun-table/": 85264,
	"./components/tables/fun-table/index": 85264,
	"./components/tables/fun-table/index.jsx": 85264,
	"./components/tables/guess-table": 65650,
	"./components/tables/guess-table/": 65650,
	"./components/tables/guess-table/index": 65650,
	"./components/tables/guess-table/index.jsx": 65650,
	"./components/tables/language-table": 69621,
	"./components/tables/language-table/": 69621,
	"./components/tables/language-table/index": 69621,
	"./components/tables/language-table/index.jsx": 69621,
	"./components/tables/leaderboard-table": 85511,
	"./components/tables/leaderboard-table/": 85511,
	"./components/tables/leaderboard-table/index": 85511,
	"./components/tables/leaderboard-table/index.jsx": 85511,
	"./components/tables/maintable": 66118,
	"./components/tables/maintable/": 66118,
	"./components/tables/maintable/index": 66118,
	"./components/tables/maintable/index.jsx": 66118,
	"./components/tables/math-quiz-table": 71607,
	"./components/tables/math-quiz-table/": 71607,
	"./components/tables/math-quiz-table/index": 71607,
	"./components/tables/math-quiz-table/index.jsx": 71607,
	"./components/tables/notification-table": 55389,
	"./components/tables/notification-table/": 55389,
	"./components/tables/notification-table/index": 55389,
	"./components/tables/notification-table/index.jsx": 55389,
	"./components/tables/payment-table": 47679,
	"./components/tables/payment-table/": 47679,
	"./components/tables/payment-table/index": 47679,
	"./components/tables/payment-table/index.jsx": 47679,
	"./components/tables/questions-table": 67595,
	"./components/tables/questions-table/": 67595,
	"./components/tables/questions-table/index": 67595,
	"./components/tables/questions-table/index.jsx": 67595,
	"./components/tables/quiz-zone-table": 76095,
	"./components/tables/quiz-zone-table/": 76095,
	"./components/tables/quiz-zone-table/index": 76095,
	"./components/tables/quiz-zone-table/index.jsx": 76095,
	"./components/tables/report-table": 43556,
	"./components/tables/report-table/": 43556,
	"./components/tables/report-table/index": 43556,
	"./components/tables/report-table/index.jsx": 43556,
	"./components/tables/sliders-table": 72482,
	"./components/tables/sliders-table/": 72482,
	"./components/tables/sliders-table/index": 72482,
	"./components/tables/sliders-table/index.jsx": 72482,
	"./components/tables/user-activity-table": 60911,
	"./components/tables/user-activity-table/": 60911,
	"./components/tables/user-activity-table/index": 60911,
	"./components/tables/user-activity-table/index.jsx": 60911,
	"./components/tables/user-contes-table": 1889,
	"./components/tables/user-contes-table/": 1889,
	"./components/tables/user-contes-table/index": 1889,
	"./components/tables/user-contes-table/index.jsx": 1889,
	"./components/tables/user-lead-table": 52956,
	"./components/tables/user-lead-table/": 52956,
	"./components/tables/user-lead-table/index": 52956,
	"./components/tables/user-lead-table/index.jsx": 52956,
	"./components/tables/user-payment-table": 6042,
	"./components/tables/user-payment-table/": 6042,
	"./components/tables/user-payment-table/index": 6042,
	"./components/tables/user-payment-table/index.jsx": 6042,
	"./data/Config": 42707,
	"./data/Config.js": 42707,
	"./data/Context": 62103,
	"./data/Context.jsx": 62103,
	"./data/Reducers": 57895,
	"./data/Reducers/": 57895,
	"./data/Reducers/AudioQuizReducer": 25970,
	"./data/Reducers/AudioQuizReducer.js": 25970,
	"./data/Reducers/BadgeReducer": 73936,
	"./data/Reducers/BadgeReducer.js": 73936,
	"./data/Reducers/CategoryReducer": 55050,
	"./data/Reducers/CategoryReducer.js": 55050,
	"./data/Reducers/ContestReducer": 20853,
	"./data/Reducers/ContestReducer.js": 20853,
	"./data/Reducers/DailyQuizReducer": 34491,
	"./data/Reducers/DailyQuizReducer.js": 34491,
	"./data/Reducers/ErrorReducer": 24832,
	"./data/Reducers/ErrorReducer.js": 24832,
	"./data/Reducers/ExamReducer": 39508,
	"./data/Reducers/ExamReducer.js": 39508,
	"./data/Reducers/FaqReducer": 66029,
	"./data/Reducers/FaqReducer.js": 66029,
	"./data/Reducers/FunNLearnReducer": 85680,
	"./data/Reducers/FunNLearnReducer.js": 85680,
	"./data/Reducers/GuessTheWordReducer": 96080,
	"./data/Reducers/GuessTheWordReducer.js": 96080,
	"./data/Reducers/LanguagesReducer": 9765,
	"./data/Reducers/LanguagesReducer.js": 9765,
	"./data/Reducers/LeaderboardReducer": 46336,
	"./data/Reducers/LeaderboardReducer.js": 46336,
	"./data/Reducers/MathQuizReducer": 93445,
	"./data/Reducers/MathQuizReducer.js": 93445,
	"./data/Reducers/PlayerReducer": 61952,
	"./data/Reducers/PlayerReducer.js": 61952,
	"./data/Reducers/QuestionBankReducer": 16276,
	"./data/Reducers/QuestionBankReducer.js": 16276,
	"./data/Reducers/QuizZoneReducer": 14146,
	"./data/Reducers/QuizZoneReducer.js": 14146,
	"./data/Reducers/SettingsReducer": 59254,
	"./data/Reducers/SettingsReducer.js": 59254,
	"./data/Reducers/SliderReducer": 29529,
	"./data/Reducers/SliderReducer.js": 29529,
	"./data/Reducers/UserReducer": 79573,
	"./data/Reducers/UserReducer.js": 79573,
	"./data/Reducers/index": 57895,
	"./data/Reducers/index.js": 57895,
	"./data/Store": 16592,
	"./data/Store.js": 16592,
	"./data/language": 39981,
	"./data/language.json": 39981,
	"./data/useExtractor": 78583,
	"./data/useExtractor.js": 78583,
	"./index": 59624,
	"./index.css": 51174,
	"./index.js": 59624,
	"./logo.svg": 31100,
	"./pages": 50322,
	"./pages/": 50322,
	"./pages/activities": 84920,
	"./pages/activities/": 84920,
	"./pages/activities/[id]": 50187,
	"./pages/activities/[id].jsx": 50187,
	"./pages/activities/index": 84920,
	"./pages/activities/index.jsx": 84920,
	"./pages/admin": 32529,
	"./pages/admin/": 32529,
	"./pages/admin/index": 32529,
	"./pages/admin/index.jsx": 32529,
	"./pages/admin/user-statistics": 92258,
	"./pages/admin/user-statistics/": 92258,
	"./pages/admin/user-statistics/index": 92258,
	"./pages/admin/user-statistics/index.jsx": 92258,
	"./pages/audio-question": 34096,
	"./pages/audio-question/": 34096,
	"./pages/audio-question/create-question": 763,
	"./pages/audio-question/create-question/": 763,
	"./pages/audio-question/create-question/index": 763,
	"./pages/audio-question/create-question/index.jsx": 763,
	"./pages/audio-question/edit-audio": 65241,
	"./pages/audio-question/edit-audio/": 65241,
	"./pages/audio-question/edit-audio/index": 65241,
	"./pages/audio-question/edit-audio/index.jsx": 65241,
	"./pages/audio-question/index": 34096,
	"./pages/audio-question/index.jsx": 34096,
	"./pages/bulk-upload": 83969,
	"./pages/bulk-upload/": 83969,
	"./pages/bulk-upload/index": 83969,
	"./pages/bulk-upload/index.jsx": 83969,
	"./pages/category": 67854,
	"./pages/category-order": 87159,
	"./pages/category-order/": 87159,
	"./pages/category-order/index": 87159,
	"./pages/category-order/index.jsx": 87159,
	"./pages/category.jsx": 67854,
	"./pages/contest": 7436,
	"./pages/contest/": 7436,
	"./pages/contest/[id]": 86757,
	"./pages/contest/[id].jsx": 86757,
	"./pages/contest/create-contest": 98164,
	"./pages/contest/create-contest/": 98164,
	"./pages/contest/create-contest/index": 98164,
	"./pages/contest/create-contest/index.jsx": 98164,
	"./pages/contest/create-question": 98277,
	"./pages/contest/create-question/": 98277,
	"./pages/contest/create-question/index": 98277,
	"./pages/contest/create-question/index.jsx": 98277,
	"./pages/contest/distribute-prize": 47843,
	"./pages/contest/distribute-prize/": 47843,
	"./pages/contest/distribute-prize/index": 47843,
	"./pages/contest/distribute-prize/index.jsx": 47843,
	"./pages/contest/edit-contest": 96517,
	"./pages/contest/edit-contest/": 96517,
	"./pages/contest/edit-contest/index": 96517,
	"./pages/contest/edit-contest/index.jsx": 96517,
	"./pages/contest/index": 7436,
	"./pages/contest/index.jsx": 7436,
	"./pages/contest/questions": 93627,
	"./pages/contest/questions.jsx": 93627,
	"./pages/daily-quiz": 68233,
	"./pages/daily-quiz/": 68233,
	"./pages/daily-quiz/create-question": 27305,
	"./pages/daily-quiz/create-question/": 27305,
	"./pages/daily-quiz/create-question/index": 27305,
	"./pages/daily-quiz/create-question/index.jsx": 27305,
	"./pages/daily-quiz/index": 68233,
	"./pages/daily-quiz/index.jsx": 68233,
	"./pages/exam-module": 5672,
	"./pages/exam-module/": 5672,
	"./pages/exam-module/create-exam": 10452,
	"./pages/exam-module/create-exam/": 10452,
	"./pages/exam-module/create-exam/index": 10452,
	"./pages/exam-module/create-exam/index.jsx": 10452,
	"./pages/exam-module/create-question": 204,
	"./pages/exam-module/create-question/": 204,
	"./pages/exam-module/create-question/index": 204,
	"./pages/exam-module/create-question/index.jsx": 204,
	"./pages/exam-module/index": 5672,
	"./pages/exam-module/index.jsx": 5672,
	"./pages/exam-module/questions": 19294,
	"./pages/exam-module/questions.jsx": 19294,
	"./pages/fun": 4211,
	"./pages/fun/": 4211,
	"./pages/fun/create-fun": 32085,
	"./pages/fun/create-fun/": 32085,
	"./pages/fun/create-fun/index": 32085,
	"./pages/fun/create-fun/index.jsx": 32085,
	"./pages/fun/create-question": 6290,
	"./pages/fun/create-question/": 6290,
	"./pages/fun/create-question/index": 6290,
	"./pages/fun/create-question/index.jsx": 6290,
	"./pages/fun/edit-fun": 15910,
	"./pages/fun/edit-fun/": 15910,
	"./pages/fun/edit-fun/index": 15910,
	"./pages/fun/edit-fun/index.jsx": 15910,
	"./pages/fun/index": 4211,
	"./pages/fun/index.jsx": 4211,
	"./pages/fun/questions": 81091,
	"./pages/fun/questions.jsx": 81091,
	"./pages/guess-the-word": 48318,
	"./pages/guess-the-word/": 48318,
	"./pages/guess-the-word/create-guess-the-word": 78981,
	"./pages/guess-the-word/create-guess-the-word/": 78981,
	"./pages/guess-the-word/create-guess-the-word/index": 78981,
	"./pages/guess-the-word/create-guess-the-word/index.jsx": 78981,
	"./pages/guess-the-word/edit-guess-the-word": 73106,
	"./pages/guess-the-word/edit-guess-the-word/": 73106,
	"./pages/guess-the-word/edit-guess-the-word/index": 73106,
	"./pages/guess-the-word/edit-guess-the-word/index.jsx": 73106,
	"./pages/guess-the-word/index": 48318,
	"./pages/guess-the-word/index.jsx": 48318,
	"./pages/index": 50322,
	"./pages/index.jsx": 50322,
	"./pages/leaderboard": 75592,
	"./pages/leaderboard/": 75592,
	"./pages/leaderboard/[id]": 59931,
	"./pages/leaderboard/[id].jsx": 59931,
	"./pages/leaderboard/index": 75592,
	"./pages/leaderboard/index.jsx": 75592,
	"./pages/math-quiz": 95558,
	"./pages/math-quiz/": 95558,
	"./pages/math-quiz/create-question": 26602,
	"./pages/math-quiz/create-question/": 26602,
	"./pages/math-quiz/create-question/index": 26602,
	"./pages/math-quiz/create-question/index.jsx": 26602,
	"./pages/math-quiz/edit-question": 64881,
	"./pages/math-quiz/edit-question/": 64881,
	"./pages/math-quiz/edit-question/index": 64881,
	"./pages/math-quiz/edit-question/index.jsx": 64881,
	"./pages/math-quiz/index": 95558,
	"./pages/math-quiz/index.jsx": 95558,
	"./pages/notifications": 53173,
	"./pages/notifications/": 53173,
	"./pages/notifications/index": 53173,
	"./pages/notifications/index.jsx": 53173,
	"./pages/overview": 70141,
	"./pages/overview/": 70141,
	"./pages/overview/index": 70141,
	"./pages/overview/index.jsx": 70141,
	"./pages/overview/questions": 74930,
	"./pages/overview/questions/": 74930,
	"./pages/overview/questions/index": 74930,
	"./pages/overview/questions/index.jsx": 74930,
	"./pages/payment": 425,
	"./pages/payment/": 425,
	"./pages/payment/[id]": 47341,
	"./pages/payment/[id]/": 47341,
	"./pages/payment/[id]/index": 47341,
	"./pages/payment/[id]/index.jsx": 47341,
	"./pages/payment/index": 425,
	"./pages/payment/index.jsx": 425,
	"./pages/question-bank": 80315,
	"./pages/question-bank/": 80315,
	"./pages/question-bank/create-question": 98020,
	"./pages/question-bank/create-question/": 98020,
	"./pages/question-bank/create-question/index": 98020,
	"./pages/question-bank/create-question/index.jsx": 98020,
	"./pages/question-bank/import-questions": 88196,
	"./pages/question-bank/import-questions/": 88196,
	"./pages/question-bank/import-questions/index": 88196,
	"./pages/question-bank/import-questions/index.jsx": 88196,
	"./pages/question-bank/index": 80315,
	"./pages/question-bank/index.jsx": 80315,
	"./pages/question-bank/question-report": 99914,
	"./pages/question-bank/question-report/": 99914,
	"./pages/question-bank/question-report/index": 99914,
	"./pages/question-bank/question-report/index.jsx": 99914,
	"./pages/quiz-zone": 48678,
	"./pages/quiz-zone/": 48678,
	"./pages/quiz-zone/create-questions": 34842,
	"./pages/quiz-zone/create-questions/": 34842,
	"./pages/quiz-zone/create-questions/index": 34842,
	"./pages/quiz-zone/create-questions/index.jsx": 34842,
	"./pages/quiz-zone/edit-question": 5326,
	"./pages/quiz-zone/edit-question/": 5326,
	"./pages/quiz-zone/edit-question/index": 5326,
	"./pages/quiz-zone/edit-question/index.jsx": 5326,
	"./pages/quiz-zone/import-questions": 40229,
	"./pages/quiz-zone/import-questions/": 40229,
	"./pages/quiz-zone/import-questions/index": 40229,
	"./pages/quiz-zone/import-questions/index.jsx": 40229,
	"./pages/quiz-zone/index": 48678,
	"./pages/quiz-zone/index.jsx": 48678,
	"./pages/quiz-zone/question-report": 20714,
	"./pages/quiz-zone/question-report/": 20714,
	"./pages/quiz-zone/question-report/index": 20714,
	"./pages/quiz-zone/question-report/index.jsx": 20714,
	"./pages/settings": 27837,
	"./pages/settings/": 27837,
	"./pages/settings/about-us": 99156,
	"./pages/settings/about-us.jsx": 99156,
	"./pages/settings/about-us/": 53974,
	"./pages/settings/about-us/index": 53974,
	"./pages/settings/about-us/index.jsx": 53974,
	"./pages/settings/badge-settings": 8970,
	"./pages/settings/badge-settings/": 8970,
	"./pages/settings/badge-settings/index": 8970,
	"./pages/settings/badge-settings/index.jsx": 8970,
	"./pages/settings/contact-us": 13576,
	"./pages/settings/contact-us.jsx": 13576,
	"./pages/settings/contact-us/": 1215,
	"./pages/settings/contact-us/index": 1215,
	"./pages/settings/contact-us/index.jsx": 1215,
	"./pages/settings/faq": 45567,
	"./pages/settings/faq/": 45567,
	"./pages/settings/faq/index": 45567,
	"./pages/settings/faq/index.jsx": 45567,
	"./pages/settings/howtoplay": 83635,
	"./pages/settings/howtoplay.jsx": 83635,
	"./pages/settings/icons-settings": 96859,
	"./pages/settings/icons-settings/": 96859,
	"./pages/settings/icons-settings/index": 96859,
	"./pages/settings/icons-settings/index.jsx": 96859,
	"./pages/settings/index": 27837,
	"./pages/settings/index.jsx": 27837,
	"./pages/settings/language-settings": 10659,
	"./pages/settings/language-settings/": 10659,
	"./pages/settings/language-settings/index": 10659,
	"./pages/settings/language-settings/index.jsx": 10659,
	"./pages/settings/payment-settings": 98597,
	"./pages/settings/payment-settings/": 98597,
	"./pages/settings/payment-settings/index": 98597,
	"./pages/settings/payment-settings/index.jsx": 98597,
	"./pages/settings/privacy-policy": 97834,
	"./pages/settings/privacy-policy.jsx": 97834,
	"./pages/settings/privacy-policy/": 58527,
	"./pages/settings/privacy-policy/index": 58527,
	"./pages/settings/privacy-policy/index.jsx": 58527,
	"./pages/settings/sliders": 4039,
	"./pages/settings/sliders/": 4039,
	"./pages/settings/sliders/index": 4039,
	"./pages/settings/sliders/index.jsx": 4039,
	"./pages/settings/system-utilities": 8722,
	"./pages/settings/system-utilities/": 8722,
	"./pages/settings/system-utilities/index": 8722,
	"./pages/settings/system-utilities/index.jsx": 8722,
	"./pages/settings/terms": 39562,
	"./pages/settings/terms.jsx": 39562,
	"./pages/settings/users-rights": 67126,
	"./pages/settings/users-rights/": 67126,
	"./pages/settings/users-rights/index": 67126,
	"./pages/settings/users-rights/index.jsx": 67126,
	"./pages/settings/welcome-bonus": 94402,
	"./pages/settings/welcome-bonus/": 94402,
	"./pages/settings/welcome-bonus/index": 94402,
	"./pages/settings/welcome-bonus/index.jsx": 94402,
	"./pages/users": 99379,
	"./pages/users/": 99379,
	"./pages/users/index": 99379,
	"./pages/users/index.jsx": 99379,
	"./pages/users/user-statistics": 8020,
	"./pages/users/user-statistics/": 8020,
	"./pages/users/user-statistics/index": 8020,
	"./pages/users/user-statistics/index.jsx": 8020,
	"./reportWebVitals": 54013,
	"./reportWebVitals.js": 54013,
	"./screens/home": 17076,
	"./screens/home.jsx": 17076,
	"./screens/login": 35209,
	"./screens/login/": 35209,
	"./screens/login/index": 35209,
	"./screens/login/index.jsx": 35209,
	"./setupTests": 79511,
	"./setupTests.js": 79511,
	"./typography.css": 92371
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;